import { createSelector } from 'reselect';
export function getPortal(state) {
  return state.portal;
}
export const getLimits = createSelector(getPortal, portal => {
  if (!('limits' in portal)) {
    return {};
  }
  return portal.limits;
});